import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";
import { catalogueOrder, type CatalogueOrder } from "../../lib/catalogueOrder";

export function CatalogueSort({ value, onChange, disabled = false }: {
	value: CatalogueOrder; onChange: (order: CatalogueOrder) => void; disabled?: boolean;
}) {
	const { t } = useTranslation();
	return <label className="catalogue-sort">
		<span className="sr-only">{t("discover.sortGames")}</span>
		<select value={value} disabled={disabled} onChange={(event) => onChange(catalogueOrder(event.target.value))}>
			<option value="featured">{t("discover.sortFeatured")}</option>
			<option value="hot">{t("discover.sortHot")}</option>
			<option value="latest">{t("discover.sortLatest")}</option>
		</select>
		<ChevronDown size={17} aria-hidden="true" />
	</label>;
}
